


























































import { Component, Vue } from 'vue-property-decorator'
import Framework7 from 'framework7'
import routes from './routes'
import firebase, { auth } from './firebase'
import { UserStoreMod } from './store/user-store'

@Component({
  // components: {
  //   LoginForm
  // }
})
export default class App extends Vue {
  f7ready = false

  f7params = {
    name: '', // App name
    theme: 'auto', // Automatic theme detection, 'auto', 'ios', 'md', 'aurora'
    // App routes
    routes: routes
  }

  created () {
    // console.log('app created')

    auth.onAuthStateChanged(user => {
      // console.log('firebase onAuthStateChanged')
      UserStoreMod.setfirebaseAuthStateLoaded()
      if (user) {
        UserStoreMod.login({
          id: user.uid,
          name: user.displayName ?? '',
          photo: user.photoURL ?? ''
        })
      } else {
        UserStoreMod.setLoggedOut()
      }
    })
  }

  mounted () {
    // console.log('app mounted')
    if (this.$f7ready) {
      this.$f7ready((f7: Framework7) => {
        // console.log('app f7ready', f7)
        this.f7ready = f7.name !== ''
      })
    }
  }

  appSignOut (): void {
    // console.log('app signOut')
    firebase.auth().signOut()
    UserStoreMod.setLoggedOut()
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.$f7!.views.main.router.navigate('/login')
  }
}
